import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';

interface BackButtonProps {
  className?: string;
  label?: string;
  onClick?: () => void;
  showLabel?: boolean;
}

const BackButton: React.FC<BackButtonProps> = ({ 
  className = '', 
  label = 'Back',
  onClick,
  showLabel = true
}) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      navigate(-1);
    }
  };

  return (
    <button
      onClick={handleClick}
      className={`group flex items-center text-gray-500 hover:text-gray-900 transition-colors ${className}`}
      aria-label={label}
    >
      <div className="p-2 rounded-full group-hover:bg-gray-100 transition-colors">
        <ArrowLeftIcon className="w-5 h-5" />
      </div>
      {showLabel && <span className="font-medium ml-1">{label}</span>}
    </button>
  );
};

export default BackButton;
